module.exports = __webpack_public_path__ + "img/line-chart-down-02.fefb0dc5.svg";